import { plainToClass } from "class-transformer";
import { UserSegment } from "src/domains/wellbeing/models/segment";

class SegmentMapping {
    static jsonToSegment(json: Record<string, unknown>): UserSegment {
        return plainToClass(UserSegment, json);
    }
}

export { SegmentMapping };
